import Image from "next/image";
import { TExperienceData } from "./Experience";

const ExperienceIcon = ({
  icon,
  company,
}: Partial<Pick<TExperienceData, "icon" | "company">>) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <Image
        src={`${icon}`}
        alt={company ?? "company"}
        width={30}
        height={30}
        sizes="30px"
      />
    </div>
  );
};

export default ExperienceIcon;
